function r(r) {
  return r.charAt(0).toUpperCase() + r.substr(1);
}
export { r as upperCaseFirst };